import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "../components/error-page";
import MalnutritionAPIContextProvider from "../contexts/MalnutritionAPIContext/Provider";
import MalnutritionCardContent from "../components/malnutrition/malnutrition-card-content";

import type { FC } from "react";

const MalnutritionPage: FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const emrPatientID = urlParams.get("emr_patient_id") ?? "mock-patient";

  return (
    <MalnutritionAPIContextProvider emrPatientID={emrPatientID}>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <MalnutritionCardContent />
      </ErrorBoundary>
    </MalnutritionAPIContextProvider>
  );
};

export default MalnutritionPage;
